import { PropsWithChildren, useState } from "react";
import { DialogResponsive } from "../../dialogs";
import { FormCreateFinanceCategory } from "./form-create-finance-category";
import { FinanceCategoryFinanceAccount } from "@/types";
import { FormUpdateFinanceCategory } from "./form-update-finance-category";

type FormCategoriesProps = PropsWithChildren & {
  category?: FinanceCategoryFinanceAccount;
};

export function FormCategories({ children, category }: FormCategoriesProps) {
  const [open, setOpen] = useState(false);
  return (
    <DialogResponsive
      title={category ? "Atualizar categoria" : "Nova categoria"}
      description={
        category
          ? "Preencha os campos para atualizar a categoria financeira."
          : "Preencha os campos para criar uma nova categoria financeira."
      }
      button={children}
      defaultOpen={open}
      setDefaultOpen={setOpen}
    >
      {category ? (
        <FormUpdateFinanceCategory
          category={category}
          handleClose={() => setOpen(false)}
        />
      ) : (
        <FormCreateFinanceCategory handleClose={() => setOpen(false)} />
      )}
    </DialogResponsive>
  );
}
